import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Table ,Pagination, Select, Input, Typography, Popconfirm, Form, Radio, Switch, Button} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import Loader from '../loader';
import { Backdrop, Box, ButtonBase, Fade, Modal } from '@mui/material';


import axios from '../apiClient';
import Alert from '../alert';




export default function Teams() {

  const [page,setPage] = useState(1);
  const [teams,setLeagues] = useState([]);
  const [totalLeagues, setTotalLeagues] = useState();
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [searchName,setSearchName] = useState('');
  const [editingKey, setEditingKey] = useState('');
  const [openAddTeamModal,setOpenAddTeamModal] = useState(false);

  async function fetchData() {
    setLoading(true)
    let res = await axios.get(`/info/getTeam?current=${page}&pageSize=10&search=${searchName}`)
    if (res.code != 200) {
        if(res.code == 404){
            setLoading(false)
            setLeagues([])
            return
        }
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setLeagues(res.data.teams)
    setTotalLeagues(res.data.pagination.total)
    setLoading(false)
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page);

  const handleSearchUsername = ({currentTarget}) => setSearchName(currentTarget.value);
  
  const handleAddTeamModalClose = () => setOpenAddTeamModal(false);
  const handleAddTeamModalOpen = () => setOpenAddTeamModal(true);
  
  const handleEdit = async()=> {

      try{
        await form.validateFields();
        const rowData = form.getFieldValue();

        const params = {
            teamId: rowData.id,
            teamNameEN: rowData.team_name_en,
            teamNameMM: rowData.team_name_mm,
            logo: rowData.logo,
        };
        setLoading(true)
        let res = await axios.put(`/info/updateTeamById`,params)
        setErrorMsg({ code: res.code, msg: res.message })
        setOpenAlert(true)
        setLoading(false)
        if(res.code == 200){
            setEditingKey("");
            fetchData();
        }
      }catch(err){
        console.log("err",err)
      }
  }

  useEffect(()=> {
    setEditingKey("")
    fetchData()
  },[searchName,page])
    
  const [form] = Form.useForm();

  const columns = [
      {
        title: 'Team Eng',
        key: 'id',
        dataIndex: 'team_name_en',
        editable: true,
      },
      {
        title: 'Team MM',
        key: 'id',
        dataIndex: 'team_name_mm',
        editable: true,
      },

      {
        title: 'operation',
        dataIndex: 'operation',
        render: (_, record) => {
          const editable = record.id === editingKey ? true : false;
          return editable ? (
            <span>
              <Typography.Link
                // onClick={handleEdit}
                style={{
                  marginRight: 8,
                }}
              >
              <Popconfirm title="Sure to save?" onConfirm={handleEdit} okButtonProps={{ loading: loading }}>
                Save
              </Popconfirm>
              </Typography.Link>
                <a onClick={()=>setEditingKey('')}>Cancel</a>
            </span>
          ) : (
            <Typography.Link  onClick={() =>
                {
            
                form.setFieldsValue({...record});
                setEditingKey(record.id)
                }
             }>
              Edit
            </Typography.Link>
          );
        },
      },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
    return col;
    }
    return {
    ...col,
    onCell: (record) => ({
        record,
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: record.id === editingKey ? true : false,
    }),
    };
  });

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <AddTeamModal openAddTeamModal={openAddTeamModal} handleAddTeamModalClose={handleAddTeamModalClose}/>
       <div style={{display: 'flex', justifyContent : 'space-between'}}>
          <Input placeholder="Team's name..."  style={{width: "20%"}} onChange={handleSearchUsername}/>
          <Button style={{marginRight: "2rem",backgroundColor: "rgb(234 234 234)", width: "20%"}} type='dashed' onClick={()=> handleAddTeamModalOpen()}>Add Team</Button>
       </div>
       <Form form={form} component={false}>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false}  dataSource={teams} 
        components={{
            body: {
            cell: EditableCell,
            },
        }}
        // bordered
        columns={mergedColumns}
        rowClassName="editable-row"
      />
      </Form>
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalLeagues} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
            rules={[
              {
                required: true,
                message: `Please Input ${title}!`,
              },
            ]}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };


  const AddTeamModal = ({openAddTeamModal: openModel,handleAddTeamModalClose: handleModelClose}) => {
    const [addTeamModalForm] = Form.useForm();
    const [loading,setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState({});
    const [openAlert, setOpenAlert] = useState(false);
    const mounted = useRef(false);

  
    useEffect(() => {
      console.log("hello")
      if(mounted.current == false) {
        mounted.current = true;
      }
    },[])
    
    const handleCloseAlert =()=> setOpenAlert(false);

  
    async function onFinish(values) {
      setLoading(true);
      let params = values;
      console.log('Values => ', params)
      const res = await axios.post(`/info/setTeam`, params);
      if(res.code == 200){
        addTeamModalForm.resetFields();
      }
      setErrorMsg({ code: res.code, msg: res.message });
      setOpenAlert(true);
      setLoading(false);    
    }
  
  
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 550,
      bgcolor: 'white',
      borderRadius: "1rem",
      boxShadow: 24,
      p: 4,
    };
    return (
      <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openModel}
          onClose={handleModelClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={openModel} >
            <Box sx={style} css={css`padding: 1.4rem 32px;`}>
              <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert} />
              <div css={css`font-family: cursive;margin-top: 1.4rem;display: flex;justify-content: center;align-items: center;font-size: 1.125rem;`}>
                Add Team
              </div>
              <Form
                name="basic"
                className="modal-points"
                style={{
                  marginTop: "2rem",
                  fontFamily: "inherit",
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                autoComplete="off"
                form={addTeamModalForm}
              >
  
                <Form.Item
                  css={css`
                        flex-basis: 50%;
                        flex-wrap : wrap;
                        .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                      `}
                  label="Team Name(English)"
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 12 }}
                  name="teamNameEN"
                  style={{ padding: "0 0.4rem", color: "white" }}
                  onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                  rules={[
                    {
                      required: true,
                      message: `Please input team name(English)!`,
                    },
                  ]}
                >
                  <Input type="text"  size="large" css={css`margin-left: 2rem;`}/>
                </Form.Item>

                <Form.Item
                  css={css`
                        flex-basis: 50%;
                        .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                      `}
                  label="Team Name(Myanamar)"
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 12 }}
                  name="teamNameMM"
                  style={{ padding: "0 0.4rem", color: "white" }}
                  rules={[
                    {
                      required: true,
                      message: `Please input team name (Myanmar)!`,
                    },
                  ]}
                >
                  <Input type="text"  size="large" css={css`margin-left: 2rem;`}/>
                </Form.Item>
                <Form.Item
                  css={css`
                        flex-basis: 50%;
                        .ant-form-item-explain-error{margin-left: 2rem !important;font-size: 0.8rem}
                      `}
                  label="Logo"
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 12 }}
                  name="logo"
                  style={{ padding: "0 0.4rem", color: "white" }}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: `Please input league name (Myanmar)!`,
                  //   },
                  // ]}
                >
                  <Input type="text"  size="large" css={css`margin-left: 2rem;`}/>
                </Form.Item>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "center",
                    padding: "0.6rem 0 0 0",
                    marginTop: "1rem",
                  }}
                >
                  <ButtonBase
                    component="button"
                    onClick={()=> {
                      addTeamModalForm.resetFields()
                      handleModelClose()
                    }
                    }
                    style={{
                      color: "black",
                      display: "flex",
                      backgroundColor: "#D27685",
                      padding: "0.6rem 1.8rem",
                      borderRadius: "2rem",
                      justifyContent: "center",
                      alignItems: "center",
                      marginRight: "1rem"
                    }}
                  >
                    <h4 style={{ textAlign: "center", margin: 0 }}>Cancel</h4>
                  </ButtonBase>
                  <ButtonBase
                    type="submit"
                    component="button"
                    style={{
                      color: "black",
                      display: "flex",
                      backgroundColor: "#408E91",
                      padding: "0.6rem 1.8rem",
                      borderRadius: "2rem",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {loading? <Loader btn creatUser/> : <h4 style={{ textAlign: "center", margin: 0 }}>Add</h4>}
                  </ButtonBase>
                
                </div>
              </Form>
            </Box>
          </Fade>
        </Modal>
    )
  }